<template min-width="650px">
  <div>
      <v-toolbar
        flat
        height="50px"
      >
        <v-toolbar-title>テンプレートを選択</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          color="black"
          style="font-size:30px"
          v-if="this.isEditing"
          @click="closeTemplate()"
        >
          <font-awesome-icon icon="fa-solid fa-xmark" />
        </v-btn>
      </v-toolbar>
    <v-container style="padding:0px;">
      <v-card
          outlined
          >
        <v-row style="display: flex;justify-content: space-evenly;padding-bottom:10px">
          <ButtonTemplateItem
            :btnCss="{
              width: '70px', borderRadius: '5px', padding: '0 15px', fontSize:'10px',
              color: 'white', backgroundColor: '#315ED9'}"
            :titleContent="'ボタン（小）'"
            :btnContent="'ボタン'"
            :beforeIcon="'fa-solid fa-envelope'"
            @click.native="onAlertAction(btnTemplate.butAutoAdjustment)"
          />
          <ButtonTemplateItem
            :btnCss="{
              width: '180px', borderRadius: '5px', padding: '0 15px', fontSize:'10px',
              color: 'white', backgroundColor: '#315ED9'}"
            :titleContent="'ボタン（大）'"
            :btnContent="'ボタン'"
            :beforeIcon="'fa-solid fa-envelope'"
            :afterIcon="'fa-solid fa-angle-right'"
            @click.native="onAlertAction(btnTemplate.btnBig)"
          />
          <ButtonTemplateItem
            :btnCss="{
              width: '240px', borderRadius: '5px', padding: '0 15px', fontSize:'10px',
              color: 'white', backgroundColor: '#315ED9'}"
            :titleContent="'ボタン（特大）'"
            :btnContent="'ボタン'"
            :beforeIcon="'fa-solid fa-envelope'"
            :afterIcon="'fa-solid fa-angle-right'"
            @click.native="onAlertAction(btnTemplate.btnXBig)"
          />
          <ButtonTemplateItem
            :btnCss="{
              width: '70px', borderRadius: '50px', padding: '0 15px', fontSize:'10px',
              color: 'white', backgroundColor: '#315ED9'}"
            :titleContent="'ラウンドボタン（小）'"
            :btnContent="'ボタン'"
            :beforeIcon="'fa-solid fa-envelope'"
            @click.native="onAlertAction(btnTemplate.rectangleButAutoAdjustment)"
          />
          <ButtonTemplateItem
            :btnCss="{
              width: '180px', borderRadius: '50px', padding: '0 15px', fontSize:'10px',
              color: 'white', backgroundColor: '#315ED9'}"
            :titleContent="'ラウンドボタン（大）'"
            :btnContent="'ボタン'"
            :beforeIcon="'fa-solid fa-envelope'"
            @click.native="onAlertAction(btnTemplate.rectangleBtnBig)"

          />
          <ButtonTemplateItem
            :btnCss="{
              width: '240px', borderRadius: '50px', padding: '0 15px', fontSize:'10px',
              color: 'white', backgroundColor: '#315ED9'}"
            :titleContent="'ラウンドボタン（特大）'"
            :btnContent="'ボタン'"
            :beforeIcon="'fa-solid fa-envelope'"
            @click.native="onAlertAction(btnTemplate.rectangleBtnXBig)"
          />
          <ButtonTemplateItem
            :btnCss="{
              width: '200px', borderRadius: '5px', padding: '0 15px', fontSize:'10px',
              color: 'white', backgroundColor: '#315ED9', boxShadow: '0 4px 0 #315ED9'}"
            :titleContent="'吹き出し付きボタン'"
            :btnContent="'資料請求をする（無料）'"
            :labelName="'speechBubble'"
            :beforeIcon="'fa-solid fa-file-lines'"
            @click.native="onAlertAction(btnTemplate.speechBubbleBtn)"
          />
          <ButtonTemplateItem
            :btnCss="{
              width: '200px', borderRadius: '5px', padding: '0 15px', fontSize:'10px',
              color: 'white', backgroundColor: '#315ED9',boxShadow: '0 4px 0 #315ED9'}"
            :titleContent="'ラベル付きボタン'"
            :btnContent="'資料請求をする（無料）'"
            :labelName="'quadrangle'"
            :afterIcon="'fa-solid fa-angles-right'"
            @click.native="onAlertAction(btnTemplate.quadrangleBtn)"
          />
          <ButtonTemplateItem
            :btnCss="{
              width: '70px', borderRadius: '50px', padding: '0 15px', fontSize:'10px',
              color: 'white', backgroundColor: '#315ED9', boxShadow: '0 2px 0 #315ED9',
              background: 'linear-gradient(to bottom,#007bff 0%,#004999 100%)'}"
            :titleContent="'グラデーションボタン'"
            :btnContent="'PUSH！'"
            :afterIcon="'fa-solid fa-angles-right'"
            @click.native="onAlertAction(btnTemplate.gradationBtn)"
          />
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import ButtonTemplateItem from './buttonTemplateItem'

export default {
  name: 'ButtonTemplate',
  components: { ButtonTemplateItem },
  props: {
    isEditing: {
      type: Boolean,
      require: true
    }
  },
  data: () => {
    return {
      btnTemplate: {
        butAutoAdjustment: {
          type: 'rectangle',
          sizeType: 'auto_adjustment',
          url: '',
          content: 'ボタン',
          fontSize: 12,
          fontColor: '#FFFFFF',
          backgroundColor: '#315ED9',
          beforeIcon: 'fa-solid fa-envelope',
          radius: '3px',
          padding: {
            x: 0,
            y: 0
          },
          boxShadow: {
            x: 0,
            y: 0,
            blur: 0,
            spread: 0
          },
          border: {
            bottom: {
              size: 0,
              color: ''
            },
            top: {
              size: 0,
              color: ''
            },
            left: {
              size: 0,
              color: ''
            },
            right: {
              size: 0,
              color: ''
            }
          }
        },
        btnBig: {
          type: 'rectangle',
          sizeType: 'btn_big',
          url: '',
          content: 'ボタン',
          fontSize: 12,
          fontColor: '#FFFFFF',
          backgroundColor: '#315ED9',
          beforeIcon: 'fa-solid fa-envelope',
          afterIcon: 'fa-solid fa-angle-right',
          radius: '3px',
          padding: {
            x: 0,
            y: 0
          },
          boxShadow: {
            x: 0,
            y: 0,
            blur: 0,
            spread: 0
          },
          border: {
            bottom: {
              size: 0,
              color: ''
            },
            top: {
              size: 0,
              color: ''
            },
            left: {
              size: 0,
              color: ''
            },
            right: {
              size: 0,
              color: ''
            }
          }
        },
        btnXBig: {
          type: 'rectangle',
          sizeType: 'btn_x_big',
          url: '',
          content: 'ボタン',
          fontSize: 12,
          fontColor: '#FFFFFF',
          backgroundColor: '#315ED9',
          beforeIcon: 'fa-solid fa-envelope',
          afterIcon: 'fa-solid fa-angle-right',
          radius: '3px',
          padding: {
            x: 0,
            y: 0
          },
          boxShadow: {
            x: 0,
            y: 0,
            blur: 0,
            spread: 0
          },
          border: {
            bottom: {
              size: 0,
              color: ''
            },
            top: {
              size: 0,
              color: ''
            },
            left: {
              size: 0,
              color: ''
            },
            right: {
              size: 0,
              color: ''
            }
          }
        },
        rectangleButAutoAdjustment: {
          type: 'rectangle',
          sizeType: 'auto_adjustment',
          url: '',
          content: 'ボタン',
          fontSize: 12,
          fontColor: '#FFFFFF',
          backgroundColor: '#315ED9',
          beforeIcon: 'fa-solid fa-envelope',
          radius: '50px',
          padding: {
            x: 0,
            y: 0
          },
          boxShadow: {
            x: 0,
            y: 0,
            blur: 0,
            spread: 0
          },
          border: {
            bottom: {
              size: 0,
              color: ''
            },
            top: {
              size: 0,
              color: ''
            },
            left: {
              size: 0,
              color: ''
            },
            right: {
              size: 0,
              color: ''
            }
          }
        },
        rectangleBtnBig: {
          type: 'rectangle',
          sizeType: 'btn_big',
          url: '',
          content: 'ボタン',
          fontSize: 12,
          fontColor: '#FFFFFF',
          backgroundColor: '#315ED9',
          beforeIcon: 'fa-solid fa-envelope',
          radius: '50px',
          padding: {
            x: 0,
            y: 0
          },
          boxShadow: {
            x: 0,
            y: 0,
            blur: 0,
            spread: 0
          },
          border: {
            bottom: {
              size: 0,
              color: ''
            },
            top: {
              size: 0,
              color: ''
            },
            left: {
              size: 0,
              color: ''
            },
            right: {
              size: 0,
              color: ''
            }
          }
        },
        rectangleBtnXBig: {
          type: 'rectangle',
          sizeType: 'btn_x_big',
          url: '',
          content: 'ボタン',
          fontSize: 12,
          fontColor: '#FFFFFF',
          backgroundColor: '#315ED9',
          beforeIcon: 'fa-solid fa-envelope',
          radius: '50px',
          padding: {
            x: 0,
            y: 0
          },
          boxShadow: {
            x: 0,
            y: 0,
            blur: 0,
            spread: 0
          },
          border: {
            bottom: {
              size: 0,
              color: ''
            },
            top: {
              size: 0,
              color: ''
            },
            left: {
              size: 0,
              color: ''
            },
            right: {
              size: 0,
              color: ''
            }
          }
        },
        speechBubbleBtn: {
          type: 'rectangle',
          sizeType: 'btn_big',
          url: '',
          content: '資料請求をする（無料）',
          labelText: '物件の資料を見たい方はコチラ！',
          labelType: 'speech_bubble',
          fontSize: 12,
          fontColor: '#FFFFFF',
          backgroundColor: '#315ED9',
          beforeIcon: 'fa-solid fa-file-lines',
          radius: '3px',
          padding: {
            x: 0,
            y: 0
          },
          boxShadow: {
            x: 0,
            y: 0,
            blur: 0,
            spread: 0
          },
          border: {
            bottom: {
              size: 5,
              color: '#003D96'
            },
            top: {
              size: 0,
              color: ''
            },
            left: {
              size: 0,
              color: ''
            },
            right: {
              size: 0,
              color: ''
            }
          }
        },
        quadrangleBtn: {
          type: 'rectangle',
          sizeType: 'btn_big',
          url: '',
          content: '資料請求をする（無料）',
          labelText: '物件の資料を見たい方はコチラ！',
          labelType: 'quadrangle',
          fontSize: 12,
          fontColor: '#FFFFFF',
          backgroundColor: '#315ED9',
          afterIcon: 'fa-solid fa-angles-right',
          radius: '3px',
          padding: {
            x: 0,
            y: 0
          },
          boxShadow: {
            x: 0,
            y: 0,
            blur: 0,
            spread: 0
          },
          border: {
            bottom: {
              size: 5,
              color: '#003D96'
            },
            top: {
              size: 0,
              color: ''
            },
            left: {
              size: 0,
              color: ''
            },
            right: {
              size: 0,
              color: ''
            }
          }
        },
        gradationBtn: {
          type: 'rectangle',
          sizeType: 'auto_adjustment',
          url: '',
          content: 'PUSH！',
          fontSize: 12,
          fontColor: '#FFFFFF',
          backgroundColor: '#315ED9',
          gradientColor: '#03356C',
          afterIcon: 'fa-solid fa-angles-right',
          radius: '50px',
          padding: {
            x: 0,
            y: 0
          },
          boxShadow: {
            x: 0,
            y: 3,
            blur: 3,
            spread: 1
          },
          border: {
            bottom: {
              size: 0,
              color: ''
            },
            top: {
              size: 0,
              color: ''
            },
            left: {
              size: 0,
              color: ''
            },
            right: {
              size: 0,
              color: ''
            }
          }
        }
      }

    }
  },
  methods: {
    closeTemplate () {
      this.$emit('close-template')
    },
    onAlertAction (templateData) {
      if (this.isEditing) {
        let res = confirm('設定内容が一部上書きされますが、よろしいですか？')
        if (res === true) {
          this.$emit('set-template', templateData)
        }
      } else {
        this.$emit('set-template', templateData)
      }
    }
  }
}
</script>
